module.exports = __webpack_public_path__ + "img/app.6875d45a.png";